// PrimeVue 4.5.5 (bug #8534): nei DatePicker con orario (showTime / timeOnly) un valore scritto a
// mano non arriva mai al modello. Con le 24 ore il testo non ha AM/PM, populateTime fa
// `ampm.toLowerCase()` su undefined, l'errore lo inghiotte onInput e all'uscita dal campo torna il
// valore di prima. La 5.0.4 lo ha corretto con `!!ampm &&`; sulla 4.x la correzione non è uscita.
// Questa è la populateTime della 5.0.4. Da togliere (con il plugin datepicker-orario) quando il
// test «PrimeVue ha ancora il bug» fallisce.
function populateTime(value, timeString, ampm) {
  if (this.hourFormat == "12" && !ampm) {
    throw "Invalid Time";
  }

  this.pm = !!ampm && (ampm.toLowerCase() === this.$primevue.config.locale.pm.toLowerCase() || ampm.toLowerCase() === "pm");
  const time = this.parseTime(timeString);

  value.setHours(time.hour);
  value.setMinutes(time.minute);
  value.setSeconds(time.second);
}

// Va chiamata prima che si crei il primo DatePicker: Vue legge i metodi alla creazione dell'istanza.
export function correggiDatePicker(DatePicker) {
  DatePicker.methods.populateTime = populateTime;
}
